import { useContext, useMemo } from 'react';
import { AuthContext } from '@/context/auth-context';
import { Collection } from '@/types/source-types';

export function useCollectionRole(collection: Collection | null) {
  const { isAdmin } = useContext(AuthContext);

  const canEdit = useMemo(() => {
    if (isAdmin) return true;
    if (!collection?.user_role) return false;
    return (
      collection.user_role === 'owner' || collection.user_role === 'editor'
    );
  }, [isAdmin, collection?.user_role]);

  const canShare = useMemo(() => {
    if (isAdmin) return true;
    return collection?.user_role === 'owner';
  }, [isAdmin, collection?.user_role]);

  const canDelete = useMemo(() => {
    if (isAdmin) return true;
    return collection?.user_role === 'owner';
  }, [isAdmin, collection?.user_role]);

  return { canEdit, canShare, canDelete };
}
